import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Button, Divider } from 'antd';
import dialog from '../../../common/utility/dialog';
import moment from "moment";
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, FORMAT_NUMBER_NO_ZERO, GREATER_THAN_ZERO } from "../../../common/types/regularExpresionType";
import global from '../../../common/utility/global';

const { Option } = Select;
const InputGroup = Input.Group;
const { Search } = Input;
const { TextArea } = Input;

class FormModalSolicitud extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {

            if (!err) {
                const form = {
                    id: values.id,
                    fechaApertura: values.fechaApertura.format("DD/MM/YYYY"),
                    idCentroCosto: values.idCentroCosto.key,
                    idEmpleado: values.idResponsable.key,
                    idMoneda: values.idMoneda,
                    motivo: values.motivo,
                    montoSolicitud: parseFloat(values.montoSolicitud),
                }

                const validFormLogic = this.validateFormLogic(form, values);
                if (!validFormLogic) {
                    return;
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    validateFormLogic = (data, values) => {

        if (data.idEmpleado === 0) {
            dialog.warning("Responsable ingresado es invalido.");
            return false;
        }

        if (data.montoSolicitud > this.props.formValues.montoDisponible) {
            dialog.warning("El monto a solicitar tiene que ser menor o igual al monto disponible.");
            return false;
        }

        return true;
    };



    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('idMoneda', { initialValue: this.props.formValues.idMoneda });

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Nueva Solicitud de Efectivo " + this.props.formValues.nroCajaChica : "Modificar Solicitud de Efectivo " + this.props.formValues.nroCajaChica}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>

                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label={"Fecha Solicitud"}>
                                {getFieldDecorator("fechaApertura", {
                                    initialValue: moment(
                                        this.props.formValues.fechaApertura,
                                        "DD/MM/YYYY"
                                    ),
                                    rules: [
                                        {
                                            type: "object",
                                            required: true,
                                            message: "Requerido",
                                        },
                                    ],
                                })(
                                    <DatePicker
                                        className="first-input"
                                        placeholder="Seleccione fecha"
                                        prefix={
                                            <Icon
                                                type="filter"
                                                style={{ color: "rgba(0,0,0,.25)" }}
                                            />
                                        }
                                        format="DD/MM/YYYY"
                                        allowClear={false}

                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Centro Costo">
                                {getFieldDecorator("idCentroCosto", {
                                    initialValue: this.props.formValues.idCentroCosto
                                        ? { key: this.props.formValues.idCentroCosto }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        }],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Centro Costo"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({
                                                idResponsable: undefined,
                                            },
                                                () => { this.props.onChange("idCentroCosto", option.key, this.props.form) }
                                            );
                                        }}
                                    >
                                        {this.props.formValues.centroCosto.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12">

                            <Form.Item label="Empleado">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator("idResponsable", {
                                            initialValue: this.props.formValues.idResponsable
                                                ? { key: this.props.formValues.idResponsable }
                                                : undefined,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Campo obligatorio.",
                                                },
                                            ],
                                        })(

                                            <Select
                                                showSearch
                                                labelInValue
                                                placeholder={"Seleccione Empleado"}
                                                optionFilterProp="children"
                                            >
                                                {this.props.formValues.empleados.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.numeroDocumento} - {item.nombre}</Option>
                                                ))}

                                            </Select>

                                        )}
                                    </Form.Item>

                                </InputGroup>


                            </Form.Item>

                        </div>
                        <div className="col-md-12">
                            <Form.Item label="Motivo">
                                {getFieldDecorator(`motivo`, {
                                    initialValue: this.props.formValues.motivo,
                                    rules: [{
                                        required: true,
                                        message: "Ingrese el valor"
                                    }]
                                })(
                                    <TextArea
                                        placeholder="Motivo"
                                        autoComplete="off"
                                        rows={4}
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-6">
                            <Form.Item label={"Monto Disponible " + (this.props.formValues.moneda)}
                                hasFeedback
                                validateStatus={this.props.formValues.montoDisponible > 0 ? "success" : "error"}>
                                {getFieldDecorator(`montoDisponible`, {
                                    initialValue: parseFloat(this.props.formValues.montoDisponible).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato (0.00)"
                                    }]
                                })(
                                    <Input
                                        placeholder="Monto Pen"
                                        autoComplete="off"
                                        readOnly
                                        id="success"
                                        onKeyPress={global.onKeyPressDecimals}
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Monto a Solicitar">

                                <Form.Item>
                                    {getFieldDecorator(`montoSolicitud`, {
                                        initialValue: parseFloat(this.props.formValues.montoSolicitud).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Mayor a 0.00"
                                        }
                                        ]
                                    })(
                                        <Input
                                            placeholder="Monto Pen"
                                            autoComplete="off"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => {
                                                this.props.form.setFieldsValue({
                                                    montoSolicitud: global.onBlurDecimals(e, 2)
                                                });
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModalSolicitud)